import { useAtom } from "jotai";

import { FklHeader } from "../../../shared/components/fkl-header/fkl-header.component";
import {
  cplOfferPageAtom,
  currentCplPageAtom,
} from "../../cpl-offer-page.state";

export function CplOfferPageHeader() {
  const [cplOfferPage] = useAtom(cplOfferPageAtom);
  const [currentCplPage] = useAtom(currentCplPageAtom);
  const { sweepstakeTitle, newGridUI } = window.FKL;

  if (newGridUI) {
    const totalEntries =
      cplOfferPage.allTimeEntries! + cplOfferPage.initialCplExtraEntries!;
    const gridTitle = `You’ve earned ${totalEntries}
    ${
      totalEntries > 1 ? "entries" : "entry"
    } in <span class="slightly-bold">${sweepstakeTitle}!</span>`;

    return (
      <div className="cpl-offer-page-v2__header">
        <FklHeader headerTitle={gridTitle} />
        <div className="cpl-offer-page__subheader-container">
          <div className="cpl-offer-page__subheader-wrapper">
            <div className="cpl-offer-page__subheader">
              <span>
                {`We found brand matches! Earn ${cplOfferPage.cplExtraEntries} extra
              entries by picking your favorites.`}
              </span>
              <span>
                <strong>
                  Pick {currentCplPage.minimumCplOffersTaken} or more brands:
                </strong>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cpl-offer-page__header">
      We found brand matches!{" "}
      <span role="img" aria-label="tada icon">
        🎉
      </span>{" "}
      Earn{" "}
      <strong>
        {cplOfferPage.cplExtraEntries} extra sweeps entries in {sweepstakeTitle}{" "}
      </strong>
      when you claim the offers:
    </div>
  );
}
